import React, { useCallback, useContext, useRef, useState } from 'react';

import Button from '../../../../../../shared/components/button';
import SvgImage from '../../../../../../shared/components/svg-image';
import { CopyLinkPopup } from '../../components/copy-link-popup';
import { ToolbarContext } from '../../index';

const copyIcon = <SvgImage imageName="chain" />;

export type CopyLinkButtonProps = {
    title?: string;
    disabled?: boolean;
    onClick: () => void;
    visible?: boolean;
    testId?: string;
};

const CopyLinkButton: React.FunctionComponent<CopyLinkButtonProps> = ({
    onClick,
    visible,
    disabled,
    title,
    testId,
}) => {
    const [isPopupVisible, setIsPopupVisible] = useState(false);

    const togglePopupVisible = useCallback(() => setIsPopupVisible(!isPopupVisible), [isPopupVisible]);

    const ref = useRef<HTMLDivElement>(null);

    const wrappedOnClick = useCallback(() => {
        togglePopupVisible();
        onClick();
    }, [onClick, togglePopupVisible]);

    const { buttonSize } = useContext(ToolbarContext);

    return visible ? (
        <>
            <CopyLinkPopup visible={isPopupVisible} anchor={ref} onClose={togglePopupVisible} />
            <div ref={ref}>
                <Button
                    title={title}
                    size={buttonSize}
                    view="neutral"
                    isDisabled={disabled}
                    icon={copyIcon}
                    onClick={wrappedOnClick}
                    testId={testId}
                />
            </div>
        </>
    ) : null;
};

export { CopyLinkButton };
